import React from 'react';
import PropTypes from 'prop-types';
import validator from 'validator';

const rules = {
  required: (value) => {
    if (!value || (Array.isArray(value) && value.length === 0)) {
      return 'Field is required';
    }
    return null;
  },
  email: (value) => {
    if (!validator.isEmail(value)) {
      return 'Invalid email';
    }
    return null;
  },
  phone: (value) => {
    if (!validator.isMobilePhone(value, 'en-IN')) {
      return 'Invalid phone';
    }
    return null;
  },
  number: (value) => {
    if (value && typeof value === 'string' && !validator.isNumeric(value)) {
      return 'Invalid number';
    }
    return null;
  },
};

class FormValidator extends React.Component {
  static propTypes = {
    validations: PropTypes.object.isRequired,
    render: PropTypes.func.isRequired,
  };

  state = {
    errorMessages: {},
  };

  validateField = (field, value) => {
    const fieldValidations = this.props.validations[field];
    const errorMessages = fieldValidations
      .map((validation) => {
        const validationRule = rules[validation];
        if (validationRule) {
          return validationRule(value);
        }
        return null;
      })
      .filter(message => !!message);

    this.setState(state => ({
      errorMessages: {
        ...state.errorMessages,
        [field]: errorMessages,
      },
    }));

    return errorMessages.length === 0;
  };

  validateAll = data => Object.keys(data)
    .map(key => this.validateField(key, data[key]))
    .every(val => val);

  render() {
    return this.props.render({
      errorMessages: this.state.errorMessages,
      validateField: this.validateField,
      validateAll: this.validateAll,
    });
  }
}

export default FormValidator;



// WEBPACK FOOTER //
// ./src/components/FormBuilder/components/FormValidator.js